import eventId from './event-id.js';
import validateSchema from './validate-schema.js';
import trafficSource from './traffic-source.js';
import useSessionId from './session-id.js';

var generateSchema = (({
  data,
  rules,
  event
} = {}) => {
  if (!event) return;
  if (data) validateSchema(data, rules, event);
  const currentUtmValues = trafficSource({
    location: window.location,
    document: window.document
  });
  return {
    eventId: eventId.generate(event),
    sessionId: useSessionId(),
    event,
    ...currentUtmValues
  };
});

export { generateSchema as default };
